import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconFormsCircleSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFormsCircleSquare"><Path d="M17.5 8.5H20.5V20.5H8.5V17.5" stroke="currentColor" strokeLinecap="square"/><Circle cx="9" cy="9" r="6.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFormsCircleSquare;
